import React from 'react';
import { Card, CardContent, Grid, TextField, CardActions, Button, CardHeader } from '@material-ui/core';
import { Link } from 'react-router-dom';
import { withSnackbar } from 'notistack'
import Email from 'validator/lib/isEmail';

// services
import UsuarioAPI from '../../../services/api/Usuario';

class NovoUsuarioPainel extends React.Component {
	state = {
		loading:false,

		nome:'',
		email:'',
		senha:'',
		confirm_senha:'',

		isNome: false,
		isSenha: false,
		isEmail: false,
		isConfirmSenha: false,
	}

	Submit = (event) => {
		const { enqueueSnackbar, history } = this.props;
		const { nome, email, senha, confirm_senha } = this.state;
		event.preventDefault();
		if (nome === '') {
			this.setState({ isNome: true }, () => enqueueSnackbar('Preencha o campo de nome'));
			return;
		}
		if (!Email(email)) {
			this.setState({ isEmail: true }, () => enqueueSnackbar('Digite um email válido!'));
			return;
		}
		if (senha === '') {
			this.setState({ isSenha: true }, () => enqueueSnackbar('Preencha o campo de senha'));
			return;
		}
		if (confirm_senha === '') {
			this.setState({ isConfirmSenha: true }, () => enqueueSnackbar('Preencha o campo de confirmação de senha'));
			return;
		}
		if (confirm_senha !== senha) {
			this.setState({ isSenha: true, isConfirmSenha: true }, () => enqueueSnackbar('A senha de confirmação não confere!'));
			return;
		}

		this.setState({ loading:true }, () => enqueueSnackbar("Aguarde efetuando o cadastro.."));
		let forms = {
			nome: nome,
			email: email,
			senha: senha,
		}
		UsuarioAPI.cadastro(forms)
					.then(res => {
						res.json().then(res => {
							if (res.msg) {
								this.setState({ loading: false }, () => enqueueSnackbar(res.msg));
								return;
							}
							enqueueSnackbar('Cadastro efetuado com sucesso');
							history.push('/painel/usuarios');
						})
					}).catch(() => this.setState({ loading: false }, () => enqueueSnackbar('Não foi possivel efetuar o cadastro, tente novamente mais tarde.')))

		return;
	}

    render() {
		const { nome, email, senha, confirm_senha, loading,
				isNome, isEmail, isSenha, isConfirmSenha } = this.state;
        return (
				<div className="app_control__content_padding" >
					<Grid container spacing={16} >
						<Grid item xs={12} >
							<form onSubmit={this.Submit} >
								<Card elevation={0} >
									<CardHeader title="Cadastro" />
									<CardContent>
										<Grid container spacing={16} >
											<Grid item xs={12} >
												<TextField
													label="Nome"
													value={nome}
													error={isNome}
													onChange={e => this.setState({ nome: e.target.value })}
													margin="normal"
													variant="outlined"
													fullWidth
												/>
											</Grid>
											<Grid item xs={12} >
												<TextField
													label="Email"
													value={email}
													error={isEmail}
													onChange={e => this.setState({ email: e.target.value })}
													margin="normal"
													variant="outlined"
													fullWidth
												/>
											</Grid>
											<Grid item xs={12} >
												<TextField
													label="Senha"
													type="password"
													value={senha}
													error={isSenha}
													onChange={e => this.setState({ senha: e.target.value })}
													margin="normal"
													variant="outlined"
													fullWidth
												/>
											</Grid>
											<Grid item xs={12} >
												<TextField
													label="Confirme a senha"
													type="password"
													value={confirm_senha}
													error={isConfirmSenha}
													onChange={e => this.setState({ confirm_senha: e.target.value })}
													margin="normal"
													variant="outlined"
													fullWidth
												/>
											</Grid>
										</Grid>
									</CardContent>
									<CardActions>
										<Button type="submit" variant="outlined" disabled={loading} color="primary" >Cadastrar</Button>
										<Button variant="outlined" color="inherit" component={Link} to="/painel/usuarios" >cancelar</Button>
									</CardActions>
								</Card>
							</form>
						</Grid>
					</Grid>
				</div>
        );
    }
}

export default withSnackbar(NovoUsuarioPainel);



// WEBPACK FOOTER //
// ./src/painel/pages/usuarios/novo.js